import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import styles from './JoinEvent.module.scss';
import ModalBase from '../ModalBase/ModalBase';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Spinner from '../../util/Spinner/Spinner';

import { hideModal } from 'legacy/actions/modalActions';
import { updateTicketInfo } from 'legacy/actions/eventActions';

interface FormModalProps {
  baseModalProps: any;
  shouldPromptBeforeClose?: boolean;
  event: {
    _id: string;
    googleForms: {
      embedUrl?: string;
      url: string;
    };
  };
  hideModal: () => void;
  updateTicketInfo: (params: { eventId: string; googleFormsAnswered: boolean }) => Promise<any>;
  onSuccess?: () => void;
  events: any[];
}

const onUnload = (e) => {
  e.preventDefault();
  e.returnValue =
    'Are you sure you want to leave? Google Forms progress will not be saved.';
};

function FormModal({
  baseModalProps,
  shouldPromptBeforeClose,
  event,
  hideModal,
  updateTicketInfo,
  onSuccess
}: FormModalProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (shouldPromptBeforeClose) {
      window.addEventListener('beforeunload', onUnload);
      return () => window.removeEventListener('beforeunload', onUnload);
    }

    return undefined;
  }, []);

  useEffect(() => {
    if (isSubmitted) {
      updateTicketInfo({
        eventId: event._id,
        googleFormsAnswered: isSubmitted
      }).then(() => {
        onSuccess?.();
      });

      window.removeEventListener('beforeunload', onUnload);
    }
  }, [isSubmitted]);

  return (
    <ModalBase
      baseModalProps={baseModalProps}
      hideBackButton
      large
      contentClassName="basic"
    >
      <div className={classnames(styles.JoinEvent, 'component')}>
        {isLoading ? (
          <div className="spinner">
            <Spinner width={100} height={100} />
          </div>
        ) : null}
        <iframe
          title="Form"
          src={event.googleForms.embedUrl || event.googleForms.url}
          width="100%"
          height="100%"
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
          onLoad={() => {
            if (isLoading) {
              setIsLoading(false);
            } else if (isLoading === false) {
              setIsSubmitted(true);
            }
          }}
        />
        {isLoading ? null : (
          <p className="googleFormsLink">
            Having trouble filling out the form?{' '}
            <a
              href={event.googleForms.url}
              target="_blank"
              rel="noreferrer"
              onClick={() => setIsSubmitted(true)}
              data-cy="forms-link"
            >
              Click here{' '}
            </a>
            to access the Google Form directly.
          </p>
        )}
        <div className="buttonRow">
          <Button
            className="alreadyCompletedButton"
            onClick={() => {
              setIsSubmitted(true);
              hideModal();
            }}
          >
            ALREADY COMPLETED
          </Button>
          <Button
            type={ButtonType.Primary}
            disabled={!isSubmitted}
            onClick={() => {
              hideModal();
            }}
          >
            CLOSE
          </Button>
        </div>
      </div>
    </ModalBase>
  );
}

FormModal.defaultProps = {
  shouldPromptBeforeClose: true
};

function mapStateToProps(state: any) {
  return { events: state.events.events };
}

const actions = { updateTicketInfo, hideModal };

export default connect(mapStateToProps, actions)(FormModal);
